import React from 'react'

export default function Footer(){
    
    return (
        <section className="main-content">
            <footer className="footer">
                <span>Copyright © {new Date().getFullYear()} Hospital Británico</span>
            </footer>
        </section>
    )
}

